import { Injectable } from "@angular/core";
@Injectable()
export class LoginModel{
    authorized:Boolean;
    ValidTo:Date;
    IsOneTimeUser:Boolean;
}